
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobs/new-grad/[slug]",
      function () {
        return require("private-next-pages/jobs/new-grad/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jobs/new-grad/[slug]"])
      });
    }
  